import { CompanySettingsController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Accounting settings.
 * @example
 * ```html
 * <salaxy-accounting-settings></salaxy-accounting-settings>
 * ```
 */

export class AccountingSettings extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = {};

  /** Uses the CompanySettingsController */
  public controller = CompanySettingsController;

  /** Default template is the view  */
  public defaultTemplate = "salaxy-components/settings/AccountingSettings.html";

}
